import CryptoJS from "crypto-js";

const secret = "ByoSyncPayWithFace";

const generateHMAC = async (dataToSign) => {
  const msg = String(dataToSign ?? "");

  // WebCrypto is only available in secure contexts (https / localhost).
  // On mobile dev over http://192.168.x.x, window.crypto.subtle is undefined.
  const subtle = window?.crypto?.subtle;
  if (!subtle?.importKey || !subtle?.sign) {
    return CryptoJS.HmacSHA256(msg, secret).toString(CryptoJS.enc.Hex);
  }

  try {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);
    const data = encoder.encode(msg);

    const key = await subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: { name: "SHA-256" } },
      false,
      ["sign"]
    );

    const signature = await subtle.sign("HMAC", key, data);
    const hexArray = Array.from(new Uint8Array(signature));
    return hexArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
  } catch {
    // Some browsers expose subtle but still fail in non-secure contexts or with restricted APIs.
    return CryptoJS.HmacSHA256(msg, secret).toString(CryptoJS.enc.Hex);
  }
};

export default generateHMAC;